import { useState,useEffect } from "react";
import { useAuthContext } from '../../adminlogin/useAuthContext';
import { useCasteContext } from "./useCasteContext";
import API_URL from "../../api/APIUrl";
import SideMenu from '../SideMenu';
import { Circles } from 'react-loader-spinner'

const AddCaste = () => {
    const {adminuser} = useAuthContext();
    const {dispatch} = useCasteContext();

    const [title,setTitle] = useState('');
    const [religion,setReligion] = useState('');
    const [allReligions,setAllReligions] = useState([]);
    const [religionError,setReligionError] = useState(null);

    const [error,setError] = useState(null);
    const [msg,setMsg] = useState(null);
    const [emptyFields,setEmptyFields] = useState([]);
    const [loading, setLoading] = useState(false); // Loading state

        
    const handleSubmit = async (e) => {
        
        e.preventDefault();
        setLoading(true); 

        try {
            if(!adminuser) {
                setLoading(false); 
                setError("You must be logged in");
                return;
            }
    
            const casteData = {title,religion};
    
            const response = await fetch(API_URL.POST_CREATE_CASTE,{
                method: 'POST',
                headers:{
                    'Content-Type' : 'application/json',
                    'Authorization': `Bearer ${adminuser.token}` 
                },
               
                body: JSON.stringify(casteData),
               
               
            });
            const json = await response.json();
            if(!response.ok){
                setLoading(false); 
                setMsg('');
                setError(json.error);
                if(json.requiredFields){
                    setEmptyFields(json.requiredFields);
                    console.log(json.requiredFields);
                }               
            }
            if(response.ok){
                setLoading(false); 
                setTitle('');
                setReligion('');
                setError(null);
                setMsg(json.msg);
                setEmptyFields([]);
                console.log("New caste added",json);
                //dispatch({type:'CREATE_RELIGION',payload:json});
        
            }
        } catch (error) {
            setLoading(false); 
            setError(error.message);
        }

        

    }

    useEffect(()=>{
        const fetchAllReligions = async () => {
            const response = await fetch(API_URL.GET_ALL_RELIGION);
            const json = await response.json();
    
            if(response.ok){
              setAllReligions(json);
            }
            else{
              setAllReligions(null);
              setReligionError('No religion data found!');
            }
        }

        fetchAllReligions();
    },[]);


    return (

        <div className="d-flex">
              <SideMenu />
              <div id="page-content-wrapper" style={{ flex: 1, padding: '20px' }}>
              <div className="container-fluid">

        <main className="form-signin">
                <div className="px-4 py-5 text-center" >
                {error && <div className="error-message">{error}</div>}
                {msg && <div className="success-message">{msg}</div>}
                 <form onSubmit={handleSubmit}>
                 <h1 className="h3 mb-3 fw-normal">Add Caste</h1>
                  
                    <div className="form-floating ">
                        <input 
                        type="text" 
                        id="titleLabel"
                        className={`form-control ${emptyFields.includes('title')? 'error':''}`}
                        onChange={(event)=> setTitle(event.target.value)}
                        value={title}
                        />
                        <label htmlFor="titleLabel">Title</label>
                    </div>
                    <div className="form-floating">
                            <select 
                            id="religionLabel"
                            className={`form-control ${emptyFields.includes('religion')? 'error':''}`}
                            onChange={(event)=> setReligion(event.target.value)}
                            value={religion}
                            >
                                <option value="">Select</option>
                                { allReligions && allReligions.map((rel) => (
                                     <option data-pg={rel.title} value={rel.title}>{rel.title}</option>
                                    ))
                                }
                            </select>
                            <label for="religionLabel">Religion</label>
                    </div>
                    <br></br>
                    <Circles
                            height="80"
                            width="80"
                            color="#4A90E2"
                            ariaLabel="circles-loading"
                            wrapperStyle={{justifyContent: "center",
                            alignItems: "center",}}
                            wrapperClass=""
                            visible={loading}
                            />              
                    <button className="btn btn-primary">Add Caste</button>
                  

                </form>
               </div>
            </main>

            </div>
            </div>

        </div>
           
    )

}

export default AddCaste;